
export class GroupImportModel {
  counter: number = 0;
  code: string = "";
  name: string = "";

  constructor(counter: number,
    code: string,
    name: string
  ){
    this.counter = counter;
    this.code = code;
    this.name = name;
  }
}